import axios from 'axios'

class IntegrationApiClient {
  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_API_INTEGRATION_URL,
    })
  }

  installSlack = async (code, token) => {
    const { data } = await this.instance.post(`/slack/install`, {
      code,
      token,
    })

    return data
  }

  uninstallSlack = async (
    firebaseToken,
    userSlackToken,
    botSlackToken,
    appName
  ) => {
    const { data } = await this.instance.post(`/slack/uninstall`, {
      firebaseToken,
      userSlackToken,
      botSlackToken,
      appName,
    })

    return data
  }

  refreshSlack = async (firebaseToken, appName) => {
    await this.instance.post(`/slack/refresh`, { firebaseToken, appName })
  }
}

export default IntegrationApiClient
